import * as React from "react";
import type { SVGProps } from "react";
const SvgFaceId02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M8.8 2.4H4.533A2.133 2.133 0 0 0 2.4 4.533v14.934c0 1.178.955 2.133 2.133 2.133h14.934a2.133 2.133 0 0 0 2.133-2.133V4.533A2.133 2.133 0 0 0 19.467 2.4H9M7.8 9.165v-1.17m8.4 1.17v-1.17M8.653 15.6c1.368 1.06 4.436 1.06 6.348 0M11.4 12.675l.249-.242c.225-.22.351-.517.351-.827V8.58"
    />
  </svg>
);
export default SvgFaceId02;
